module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0084.jpg?v=19e2d489";